import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconSendSvg } from "./IconSendSvg.mjs";
const IconSend = (props) => /* @__PURE__ */ jsx(
  IconContainer,
  {
    ...props,
    verticalCorrection: {
      uppercase: "none",
      lowercase: "up"
    },
    children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconSendSvg, ...svgProps })
  }
);
export {
  IconSend
};
